import { CSSProperties } from 'react';
import { SIGNATURE_LAYER } from './globalStyles';

export const styles: Record<string, CSSProperties> = {
  app: {
    minHeight: '100vh',
  },
  signatureLayer: SIGNATURE_LAYER,
};
